import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"]
  static controllerName = "school-pupil-navigation"

  connect() {
    this.updateActiveClass()
  }

  updateActiveClass() {
    this.linkTargets.forEach((link) => {
      const onSubpage = link.dataset.matchSubpages && window.location.href.startsWith(link.href + "/")
      if (link.href === window.location.href || onSubpage) {
        link.classList.add("is-active");
      } else {
        link.classList.remove("is-active");
      }
    });
  }
  
}
